import React, { useEffect, useState } from "react";
import "./PDFViewer.css";
import { AWS_CONFIG } from "../config/AWS";
import { getWithExpiry } from "../utils/sessionStorage";

const PDFViewer = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect if user is on mobile device
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      setIsMobile(mobileRegex.test(userAgent));
    };

    checkMobile();

    // Try to get URL from session storage first
    const hasAccess = getWithExpiry("pdfAccess");

    if (hasAccess) {
      // If not in storage or expired, use the new URL and store it
      const newUrl = AWS_CONFIG.PDF_LINK;
      setPdfUrl(newUrl);

      // Redirect mobile users directly to the PDF URL
      if (isMobile && newUrl) {
        window.location.href = newUrl;
      }
    }
  }, [isMobile]);

  if (!pdfUrl) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <div className="loading-text">Getting access to your PDF...</div>
      </div>
    );
  }

  // Only render the PDF viewer for non-mobile devices
  // Mobile users will be redirected before this renders
  return (
    <div className="pdf-viewer">
      <div className="pdf-header">
        <h2>Your PDF Document</h2>
      </div>
      <div className="pdf-container">
        <iframe
          src={`${pdfUrl}#view=FitH&toolbar=1&navpanes=1`}
          title="PDF Viewer"
          width="100%"
          height="100%"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default PDFViewer;
